import SearchForm from '../../new-car-pages/modules/search/search-form';
const noUiSlider = require('nouislider');
import caseInsensitiveCompare from '../../modules/caseInsensitiveCompare';
import getManufacturerFromBrand from '../../used-vue/api/GetManufacturerFromBrand';

export default class extends SearchForm {
    constructor(hashFragmentParams, options) {
        super(hashFragmentParams, options);
        this.optionsUrl = '/ajax/motability/options';
        this.inputs = {
            'type': {},
            'monthlyAllowance': {},
            'advanceRental': {},
            'model': {},
            'trim': {},
            'fuelType': {},
            'transmission': {},
            'bodystyle': {},
            'engineSize': {},
            'co2': {},
            'doors': {},
            'mpg_combined': {},
            'seats': {},
            'nil_advance_payment': {},
            'total_allowance': {},
        }

        this.minAdvanceRental = (typeof priceMin == 'undefined' ? 0 : priceMin);
        this.maxAdvanceRental = (typeof priceMax == 'undefined' ? 2000 : priceMax);
        this.advanceRentalSlider = null;

        this.createAdvanceRentalSlider();
    }

    setClosestMatchForSelect(sel, val) {
        let vals = [];
        for (let i=0, n=sel.options.length; i<n; i++) {
            if (sel.options[i].value) vals.push(sel.options[i].value);
        }
        sel.value = closest(val, vals);
    }

    setClosestMatchForSelects(elements, value) {
        if (elements instanceof HTMLElement && elements.tagName.toLowerCase() == 'select') {
            this.setClosestMatchForSelect(elements, value);
            return true;
        }
        if (elements.length == 0) {
            return;
        }
        for (let index = 0, elementsLength = elements.length; index < elementsLength; index++) {
            this.setClosestMatchForSelects(elements[index], value);
        }
    }

    type() {
        if (typeof this.data.type == 'undefined') {
            return;
        }

        const isChecked = this.inputs['type'][0] === 'war';

        if (isChecked) {
            $('[data-quote-toggle]')
                .toggleClass('toggle--checked')
                .find('[data-quote-type]')
                .not(':checked')
                .prop('checked', true)
        }

        this.syncAdvanceRentalSliderLabel();
    }

    syncAdvanceRentalSliderLabel() {
        if (!this.advanceRentalSlider || !this.advanceRentalSlider.noUiSlider) {
            return;
        }

        const activeMax = this.maxAdvanceRental || 0;
        const minDisplayElement = document.getElementById('minAdvanceRentalDisplay');
        const maxDisplayElement = document.getElementById('maxAdvanceRentalDisplay');
        const displayTextElement = document.getElementById('price-display');

        this.advanceRentalSlider.noUiSlider.updateOptions({
            range: {
                'min': [ 0 ],
                'max': [ activeMax ]
            }
        }, false);

        this.advanceRentalSlider.noUiSlider.set([activeMax]);

        if (displayTextElement) {
            displayTextElement.innerHTML = `£${Math.round(this.advanceRentalSlider.noUiSlider.get()).toLocaleString()}`;
        }

      

        if (minDisplayElement) {
            minDisplayElement.innerHTML = `&pound;0`;
        }

        if (maxDisplayElement) {
            maxDisplayElement.innerHTML = `&pound;${Math.round(activeMax).toLocaleString()}`;
        }

        if (this.advanceRentalMaxElement) {
            this.advanceRentalMaxElement.value = activeMax;
        }
    }

    createAdvanceRentalSlider() {
        this.advanceRentalSlider = document.getElementById('price-slider-range');
        // window.priceMobileSlider = document.getElementById('price-mobile-slider-range');
        noUiSlider.create(this.advanceRentalSlider, {
            start: [ this.maxAdvanceRental ],
            behaviour: 'drag-tap',
            connect: true,
            range: {
                'min': [ 0 ],
                'max': [ this.maxAdvanceRental ]
            },
            step: 25
        });

        this.advanceRentalSlider.noUiSlider.on('change', () => {
            this.formUpdated('price');
        });

        const displayTextElement = document.getElementById('price-display');
        const minDisplayElement = document.getElementById('minAdvanceRentalDisplay');
        const maxDisplayElement = document.getElementById('maxAdvanceRentalDisplay');

        const initialMax = this.maxAdvanceRental;
        if (displayTextElement) {
            displayTextElement.innerHTML = `£${Math.round(this.advanceRentalSlider.noUiSlider.get()).toLocaleString()}`;
        }
        if (minDisplayElement) {
            minDisplayElement.innerHTML = `&pound;0`;
        }
        if (maxDisplayElement) {
            maxDisplayElement.innerHTML = `&pound;${Math.round(initialMax).toLocaleString()}`;
        }
        if (this.advanceRentalMaxElement) {
            this.advanceRentalMaxElement.value = initialMax;
        }

        this.advanceRentalSlider.noUiSlider.on('update', ([price]) => {
            if (displayTextElement) {
                displayTextElement.innerHTML = `£${Math.round(price).toLocaleString()}`;
            }
            if (this.advanceRentalMaxElement) {
                this.advanceRentalMaxElement.value = parseInt(price);
            }
            if (maxDisplayElement) {
                maxDisplayElement.innerHTML = `&pound;${Math.round(this.maxAdvanceRental).toLocaleString()}`;
            }
        });
    }

    advanceRental() {
        if (typeof this.data.advanceRental == 'undefined') {
            return;
        }
        const min = this.data.advanceRental.min || 0;
        const max = this.data.advanceRental.max || 2000;
        if (this.minAdvanceRental !== min || this.maxAdvanceRental !== max) {
            this.minAdvanceRental = min;
            this.maxAdvanceRental = max;
            this.advanceRentalSlider.noUiSlider.updateOptions({
                range: {
                    'min': [ 0 ],
                    'max': [ max ]
                }
            });
            this.syncAdvanceRentalSliderLabel();
        }
    }

    reset_advanceRental() {
        this.advanceRentalSlider.noUiSlider.set([this.minAdvanceRental, this.maxAdvanceRental]);
    }

    resetForm() {
        Object.keys(this.inputs).forEach(index => {
            // If there's a custom reset function, call it. If the function returns true, then run the rest of the loop, otherwise return
            if (typeof this['reset_' + index] === "function") {
                if (this['reset_' + index]() !== true) {
                    return;
                }
            }

            const inputs = document.querySelectorAll("input[name='"+index+"']:checked");

            if (inputs) {
                for (let index = 0, count = inputs.length; index < count; index++) {
                    inputs[index].checked = false;
                }
            }

            const selects = document.querySelectorAll("select[name='"+index+"']");

            if (selects) {
                for (let index = 0, count = selects.length; index < count; index++) {
                    selects[index].selectedIndex = 0;
                }
            }
        });
        this.storeInputs();
        this.formUpdated('', null);
    }

    count() {
        if (typeof this.data.count !== 'undefined' && typeof this.data.maxStock !== 'undefined') {
            $('.result-count').html('Showing '+this.data.count+' of '+this.data.maxStock+' results');
        }
    }

    model() {
        if (typeof this.data.model == 'undefined') {
            return;
        }

        // this.rebuildCheckbox(
        //     document.getElementById('model-group'),
        //     this.data.model,
        //     'model',
        //     value => value,
        //     value => value,
        // );

        this.rebuildModelBox($('#modelDropdown'), 'model', 'Show all', value => value);
    }

    trim() {
        if (typeof this.data.trim == 'undefined') {
            return;
        }

        // this.rebuildCheckbox(
        //     document.getElementById('trim-group'),
        //     this.data.trim,
        //     'trim',
        //     value => value,
        //     value => value,
        // );
        this.rebuildSelectBox($('#trimDropdown'), 'trim', 'Trim', value => value);
    }

    monthlyAllowance() {
        if (typeof this.data.trim == 'undefined') {
            return;
        }

        // this.rebuildCheckbox(
        //     document.getElementById('trim-group'),
        //     this.data.trim,
        //     'trim',
        //     value => value,
        //     value => value,
        // );
        this.rebuildSelectBox($('#monthlyAllowance'), 'monthlyAllowance', 'Monthly allowance', value => {
            if (value === 'less') {
                return 'Show cars costing less than your mobility allowance';
            }

            if (value === 'total') {
                return 'Show cars using all of your mobility allowance';
            }

            return value;
        });
    }

    fuelType() {
        if (typeof this.data.fuelType == 'undefined') {
            return;
        }
        // this.rebuildCheckbox(
        //     document.getElementById('fuelType-group'),
        //     this.data.fuelType,
        //     'fuelType',
        //     value => value,
        //     value => value,
        // );
        this.rebuildSelectBox($('#fuelTypeDropdown'), 'fuelType', 'Fuel Type', value => value);
    }

    transmission() {
        if (typeof this.data.transmission == 'undefined') {
            return;
        }
        // this.rebuildCheckbox(
        //     document.getElementById('transmission-group'),
        //     this.data.transmission,
        //     'transmission',
        //     value => value,
        //     value => value,
        // );
        this.rebuildSelectBox($('#transmissionDropdown'), 'transmission', 'Transmission', value => value);
    }

    bodystyle() {
        if (typeof this.data.bodystyle == 'undefined') {
            return;
        }
        // this.rebuildCheckbox(
        //     document.getElementById('bodystyle-group'),
        //     this.data.bodystyle,
        //     'bodystyle',
        //     value => value,
        //     value => value,
        // );
        this.rebuildSelectBox($('#bodystyleDropdown'), 'bodystyle', 'Body Type', value => value);
    }

    engineSize() {
        if (typeof this.data.engineSize == 'undefined') {
            return;
        }
        // this.rebuildCheckbox(
        //     document.getElementById('engineSize-group'),
        //     this.data.engineSize,
        //     'engineSize',
        //     value => value,
        //     value => { return number_format(value,1) + ' to ' + number_format((value+0.2),1) + 'L'; },
        // );
        this.rebuildSelectBox($('#engineSizeDropdown'), 'engineSize', 'Engine Size', value => { return number_format(value,1) + ' to ' + number_format((value+0.2),1) + 'L'; });
    }

    co2() {
        if (typeof this.data.co2 == 'undefined') {
            return;
        }
        // this.rebuildCheckbox(
        //     document.getElementById('co2-group'),
        //     this.data.co2,
        //     'co2',
        //     value => value,
        //     value => { return value + ' to ' + (value + 10); },
        // );
        this.rebuildSelectBox($('#co2Dropdown'), 'co2', 'CO2 Emissions', value => { return value + ' to ' + (value + 10); });
    }

    doors() {
        if (typeof this.data.doors == 'undefined') {
            return;
        }
        // this.rebuildCheckbox(
        //     document.getElementById('doors-group'),
        //     this.data.doors,
        //     'doors',
        //     value => value,
        //     value => value,
        // );
        this.rebuildSelectBox($('#doorsDropdown'), 'doors', 'No. of Doors', value => value);
    }

    mpg_combined() {
        if (typeof this.data.mpg_combined == 'undefined') {
            return;
        }
        // this.rebuildCheckbox(
        //     document.getElementById('mpg_combined-group'),
        //     this.data.mpg_combined,
        //     'mpg_combined',
        //     value => value,
        //     value => { return value + ' to '+ (value + 10) + ' mpg'; },
        // );
        this.rebuildSelectBox($('#mpg_combinedDropdown'), 'mpg_combined', 'MPG', value => { return value + ' to '+ (value + 10) + ' mpg'; });
    }

    seats() {
        if (typeof this.data.seats == 'undefined') {
            return;
        }
        // this.rebuildCheckbox(
        //     document.getElementById('seats-group'),
        //     this.data.seats,
        //     'seats',
        //     value => value,
        //     value => value,
        // );
        this.rebuildSelectBox($('#seatsDropdown'), 'seats', 'No. of Seats', value => value);
    }

        loadFromParams(params) {
        // let triggerChange = false;
        Object.keys(params).forEach(key => {
            // Step through every checkbox and tick/untick it depending on the current set of params
            const inputs = document.querySelectorAll("input[name='"+key+"[]']");
            if (inputs.length > 0) {
                for (let index = 0, inputsLength = inputs.length; index < inputsLength; index++) {
                    inputs[index].checked = (caseInsensitiveCompare(inputs[index].value, params[key])) ? true : false;
                }
            }

            // Step through every radio and tick/untick it depending on the current set of params
            const radioInputs = document.querySelectorAll("input[name='"+key+"']");
            if (radioInputs.length > 0) {
                for (let index = 0, inputsLength = radioInputs.length; index < inputsLength; index++) {
                    radioInputs[index].checked = (caseInsensitiveCompare(radioInputs[index].value, params[key])) ? true : false;
                }
            }

            // Store the param value as a single value so select elements, text elements and sliders can use it.
            const singleValue = (Array.isArray(params[key])) ? params[key][0] : params[key];

            // Step through the select elements and make sure they're updated too
            const selectElements = document.querySelectorAll("select[name='"+key+"']");
            if (selectElements.length > 0) {
                for (let index = 0, selectElementsLength = selectElements.length; index < selectElementsLength; index++) {
                    selectElements[index].value = singleValue;
                }
            }

            const priceSlider = document.getElementById('price-slider-range');

            if (key == 'maxAdvanceRental' && singleValue) {
                priceSlider.noUiSlider.set([parseInt(singleValue)]);
            }
            if (key == 'finance') {
                try {
                    setValue(document.getElementById('finance-type'), singleValue);
                } catch (error) {
                    // Do nothing
                }
            }
            if (key == 'postcode') {
                let cleanValue = singleValue;
                if (typeof cleanValue == 'string') {
                    cleanValue = cleanValue.replace(/[^0-9a-z\s]/gi, '');
                }
                setCookieValue('new_postcode', cleanValue);
                setValue(document.querySelectorAll("input[name='postcode']"), cleanValue);
            }
            if (key == 'age') {
                setCookieValue('new_age', parseInt(singleValue));
                setValue(document.querySelectorAll("input[name='age']"), singleValue);
            }
            if (key == 'mileage') {
                this.setClosestMatchForSelects(document.querySelectorAll("select[name='mileage']"), parseInt(singleValue));
            }
            if (key == 'term') {
                this.setClosestMatchForSelects(document.querySelectorAll("select[name='term']"), parseInt(singleValue));
            }
            if (key == 'deposit') {
                setValue(document.querySelectorAll("input[name='deposit']"), singleValue);
            }
        });
    }

    promotions() {
        if (typeof this.data.promotions == 'undefined') {
            return;
        }

        let promotions = false;
        Object.keys(this.data.promotions).forEach(key => {
            const target = document.querySelector('.refine-search__promotion input[id="'+key+'"]');
            if (this.data.promotions[key] > 0) {
                target.parentElement.style.removeProperty('display');
                promotions = true;
            } else {
                target.parentElement.style.display = 'none';
            }
        });

        if (promotions === true) {
            document.querySelector('.refine-search__promotion').style.removeProperty('display');
        } else {
            document.querySelector('.refine-search__promotion').style.display = 'none';
        }
    }

    //    formUpdated(whatWasUpdated = 'all', eventTarget = null) {
    //     return new Promise((resolve, reject) => {
    //         this.lastUpdated = whatWasUpdated;
    //         if (typeof this['inputClicked_' + whatWasUpdated] === "function") {
    //             this['inputClicked_' + whatWasUpdated](eventTarget);
    //         }

    //         this.storeInputs();

    //         // AJAX request to get new search options
    //         axios({
    //             method: 'post',
    //             url: this.optionsUrl,
    //             data: this.formData(),
    //         })
    //         .then(response => {

    //             if (response.data.count === 0) {
    //                 const brand = getManufacturerFromBrand(window.brand);

    //                 document.getElementById('search-results').innerHTML = `
    //                     <h3 class="no-results">There are no results for this search. To search our ${brand} Motability Nil Advance Payment Cars please <a class="no-results__link" href="/${window.brand}/motability/nil-advance-payment">click here</a></h3>
    //                 `;
    //                 return;
    //             }

    //             this.setResponse(response.data);

    //             // Trigger the hash fragment update after options are loaded
    //             this.updateUrl();

    //         }).catch(error => {
    //             console.error(error);
    //         });
    //     });
    // }

    rebuildModelBox($select, requestIndex, title, formatFunction) {
        if (typeof this.data[requestIndex] === 'undefined') {
            return false;
        }

        const arrayOfNewOptions = this.data[requestIndex];

        let checkPreviousValueIsPresent = false;
        let previousSelectedOption = $select[0].options[$select[0].selectedIndex];
        let previousSelectedValue, previousSelectedText, previousSelectedData;

        if (previousSelectedOption) {
            previousSelectedValue = previousSelectedOption.value;
            previousSelectedText = previousSelectedOption.innerHTML;
            previousSelectedData = previousSelectedOption.dataset.newModelId;
        }

        $select
            .empty()
            .append($('<option/>',  { value: '', text: title }));

        Object.keys(arrayOfNewOptions).forEach(key => {
            const model = arrayOfNewOptions[key];
            const isSelected = this.inputs[requestIndex].indexOf(model.short_name) >= 0;

            if (isSelected) {
                checkPreviousValueIsPresent = true;
            }

            $select.append($('<option/>', {
                value: model.short_name,
                text: formatFunction(model.short_name),
                selected: isSelected,
                'data-new-model-id': model.id,
            }));
        });

        if (!checkPreviousValueIsPresent && previousSelectedOption && previousSelectedValue != '') {
            let options = {
                value: previousSelectedValue,
                text: previousSelectedText,
                selected: true,
            };
            if (previousSelectedData) {
                options['data-new-model-id'] = previousSelectedData;
            }
            $select.append($('<option/>', options));
        }
    }
}